export default {
  UPDATE_COLLAPSE_ACADEMIC_OVERVIEW: 'UPDATE_COLLAPSE_ACADEMIC_OVERVIEW',
  UPDATE_COLLAPSE_APPLICATION_STATUS: 'UPDATE_COLLAPSE_APPLICATION_STATUS',
  UPDATE_COLLAPSE_SCATTERGRAM: 'UPDATE_COLLAPSE_SCATTERGRAM',
  UPDATE_COLLAPSE_CHECKLIST: 'UPDATE_COLLAPSE_CHECKLIST',
  UPDATE_COLLAPSE_DOCUMENT_STATUS: 'UPDATE_COLLAPSE_DOCUMENT_STATUS',
  UPDATE_COLLAPSE_PROSPECT_HISTORY: 'UPDATE_COLLAPSE_PROSPECT_HISTORY',
}
